export default "__VITE_ASSET__mHhS31nU__"